<template>
  <div class="user-list">
    <div style="display: flex; align-items: center">
      <div class="left">
        <div class="search-bar">
          <el-input
            v-model="searchParam.keyword_search"
            placeholder="输入要搜索的内容"
            clearable
            @clear="getList"
          ></el-input>
          <el-button type="primary" @click="getList">查询</el-button>
        </div>
        <el-tabs v-model="searchParam.play_status" type="card" @tab-click="getList">
          <el-tab-pane label="全部" name="0"></el-tab-pane>
          <el-tab-pane label="未开始" name="1"></el-tab-pane>
          <el-tab-pane label="直播中" name="2"></el-tab-pane>
          <el-tab-pane label="已关闭" name="3"></el-tab-pane>
        </el-tabs>
      </div>
      <div class="right">
        <div>
          <span>{{ pageData.live_count }}</span>
          <p>直播总数</p>
        </div>
        <div>
          <span>{{ pageData.online_people }}</span>
          <p>在线人数</p>
        </div>
      </div>
    </div>

    <div class="table">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="house_id" label="直播id" fixed="left"> </el-table-column>
        <el-table-column prop="title" label="课程名称"> </el-table-column>
        <el-table-column prop="teacher_name" label="教师姓名"> </el-table-column>
        <el-table-column prop="total_people" label="当前人数"> </el-table-column>
        <el-table-column prop="count_people" label="历史最高人数" width="120"></el-table-column>
        <el-table-column prop="total_report" label="报名人数"> </el-table-column>
        <el-table-column prop="count_time" label="直播时长"> </el-table-column>
        <el-table-column prop="play_status" label="直播状态">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.play_status == 2" type="success">直播中</el-tag>
            <el-tag v-if="scope.row.play_status == 1" type="info">未开始</el-tag>
            <el-tag v-if="scope.row.play_status == 3">已结束</el-tag>
            <el-tag v-if="scope.row.play_status == 4" type="warning">已禁用</el-tag>
          </template>
        </el-table-column>

        <el-table-column prop="start_time" label="开始时间" width="120"> </el-table-column>
        <el-table-column prop="end_time" label="结束时间" width="120"> </el-table-column>
        <el-table-column label="操作" fixed="right" width="250">
          <template slot-scope="scope">
            <el-button class="mid-blue" @click="toDetail(scope.row)">详情</el-button>
            <el-button class="mid-blue" @click="toData(scope.row)">数据</el-button>
            <el-button class="mid-red" @click="banItem(scope.row)">{{
              scope.row.play_status == 4 ? "恢复" : "禁用"
            }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          :current-page="page_index"
          :page-sizes="[10, 20, 60, 100]"
          :page-size="page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { getLiveList, roomList, startLive } from "@/api/live.js";
import { mixin } from "@/mixins/pagination.js";
export default {
  mixins: [mixin],
  data() {
    return {
      pageData: {},
      searchParam: {},
      tableData: [
        {
          id: 1,
          name: "课程",
          img: "",
          teacher: "授课老师",
          start_time: "2021-11-22",
          price: "12",
          old_price: "22",
          sale: 12,
          create_time: "2022-12-11",
        },
      ],
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    toDetail(row) {
      console.log(row);
      this.$router.push({
        path: "/watch-live",
        query: { ...row, ismanage: true },
      });
    },
    toData(row) {
      this.$router.push({
        path: "/live-data",
        query: row,
      });
    },
    // 恢复
    reStartLive(row) {
      startLive(row.live_uuid, { type: "resume" }).then((res) => {
        if (res === true) {
          this.$message.success("成功");
          this.getList();
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
    // 禁用
    banStartLive(row) {
      startLive(row.live_uuid, { type: "disable" }).then((res) => {
        console.log(res);
        if (res === true) {
          this.$message.success("成功");
          this.getList();
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
    banItem(row) {
      this.$confirm("确定要" + (row.play_status == 4 ? "恢复" : "禁用") + "该房间吗", " ", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          if (row.play_status == 4) {
            this.reStartLive(row);
          } else {
            this.banStartLive(row);
          }
        })
        .catch(() => {});
    },
    async getList() {
      const param = {
        page_index: this.page_index,
        page_size: this.page_size,
        ...this.searchParam,
      };
      this.loading = true;
      const res = await roomList(param);
      this.loading = false;

      if (res.data instanceof Array) {
        this.pageData = res;
        this.tableData = res.data;
        this.total = res.total;
      }
    },
  },
};
</script>

<style scoped="scoped" lang="less">
.user-list {
  background: white;
  padding: 10px;
  box-sizing: border-box;
}

.right {
  display: flex;
  text-align: center;
  padding: 0 10px;

  div {
    background: #f4f4f4;
    padding: 10px 20px;
    margin: 0 20px;
  }
}
</style>
